@if (attributions.size) {
  <div id="attributions">
    @if (attributions.size) {
      <a class="show-mobile" href="https://www.geonorge.no/Geodataarbeid/Norge-digitalt" target="_blank"
        >&copy; Norge digitalt</a
      >
    }
    @if (attributions.size) {
      <span class="hidden-mobile">&copy; Kartdata:</span>
    }
    @for (attrib of attributions | keyvalue; track attrib) {
      <div class="attribution-wrapper hidden-mobile">
        <a [href]="attrib.value" target="_blank">{{ attrib.key }}</a>
        <span class="separator">, </span>
      </div>
    }
  </div>
}
